import { useMutation } from "@tanstack/react-query";

interface ResetPasswordVariables {
  email: string;
  redirectTo?: string;
}

interface ResetPasswordResponse {
  success: boolean;
  error?: string;
  message?: string;
}

// Empty string means use current origin (for proxied setup), undefined means use localhost
const API_URL = import.meta.env.VITE_API_URL !== undefined
  ? import.meta.env.VITE_API_URL
  : "http://localhost:3000";

export function useResetPassword() {
  return useMutation<ResetPasswordResponse, Error, ResetPasswordVariables>({
    mutationFn: async ({ email, redirectTo }) => {
      try {
        const response = await fetch(`${API_URL}/api/auth/request-password-reset`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            email,
            redirectTo: redirectTo || `${window.location.origin}/reset-password`,
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          return {
            success: false,
            error: data.error || "Failed to send password reset email",
          };
        }

        return data;
      } catch (error) {
        const errorMessage = error instanceof Error ? error.message : "Unknown error occurred";
        return {
          success: false,
          error: errorMessage,
        };
      }
    },
  });
}
